import React, {ChangeEvent} from 'react'
import {Form} from 'react-bootstrap'
import {DiscountType} from '../../constants/Common'

interface IFormDiscountType {
  name: string
  value: DiscountType
  disabled?: boolean
  onChange(v: ChangeEvent<HTMLInputElement>): void
}

const FormDiscountType: React.FC<IFormDiscountType> = (props) => {
  const { name, value, disabled, onChange } = props

  return (
    <Form.Group className='mb-0' controlId={name}>
      <Form.Check
        disabled={disabled}
        id={`${name}_baht`}
        type={'radio'}
        label={'บาท'}
        value={DiscountType.FIXED}
        checked={value === DiscountType.FIXED}
        onChange={onChange}
        name={name}
      />
      <Form.Check
        disabled={disabled}
        id={`${name}_percent`}
        type={'radio'}
        label={'เปอร์เซ็นต์'}
        value={DiscountType.PERCENT}
        checked={value === DiscountType.PERCENT}
        onChange={onChange}
        name={name}
      />
    </Form.Group>
  )
}

export default FormDiscountType
